<!--
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2023-03-31 09:09:22
 * @LastEditors: 刘小二
 * @LastEditTime: 2023-04-01 11:36:53
 * @Description: 特殊价格
 * @FilePath: /icps_pcweb/src/views/platform/ICPS/internetSales/dialog/specialPriceDialog.vue
-->
<template>
  <el-dialog :visible.sync="specialPriceDialog" width="1500px" :close-on-click-modal="false" :before-close="close">
    <span slot="title" class="dialog-title">特殊价格配置</span>
    <div class="dialoginfo">
      <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: center; margin-bottom: 10px">
        <div>生效时间: {{ data.effectiveTime || "-" }}</div>
        <el-button class="bottom_all" style="margin-right: 24px" @click="add()">添加</el-button>
      </div>
      <div style="height: 700px; overflow-y: auto">
        <!-- 第一部分 -->
        <div>
          <el-table ref="table1" :header-cell-style="{ background: '#f3f6f9' }" border stripe style="width: 100%" height="380" :data="tableData" tooltip-effect="dark">
            <el-table-column v-for="(item, index) in table" :key="index" :prop="item.prop" :label="item.label" :width="item.width" align="center" :fixed="item.label == '操作' ? 'right' : false">
              <template slot-scope="scope">
                <span v-if="item.label == '强度等级'">
                  <el-select v-model="scope.row.strengthGradeId" placeholder="请选择" style="width: 100px">
                    <el-option v-for="item in config_options.strengthGrade" :key="item.id" :label="item.name" :value="item.id" @click.native="selectStrengthGradeFun(scope.$index, item)"> </el-option>
                  </el-select>
                </span>
                <span v-else-if="item.label == '性能等级'">
                  <el-select v-model="scope.row.performanceGradeList" multiple placeholder="请选择" style="width: 100px">
                    <el-option v-for="item in config_options.performanceGrade" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                  </el-select>
                </span>
                <span v-else-if="item.label == '材料要求'">
                  <el-select v-model="scope.row.meterialRequirementsList" multiple placeholder="请选择" style="width: 100px">
                    <el-option v-for="item in config_options.meterialRequirements" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                  </el-select>
                </span>
                <span v-else-if="item.label == '特殊要求'">
                  <el-select v-model="scope.row.specialRequirementsList" multiple placeholder="请选择" style="width: 100px">
                    <el-option v-for="item in config_options.specialRequirements" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                  </el-select>
                </span>
                <span v-else-if="item.label == '外加剂要求'">
                  <el-select v-model="scope.row.admixtureRequirementsList" multiple placeholder="请选择" style="width: 100px">
                    <el-option v-for="item in config_options.admixtureRequirements" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                  </el-select>
                </span>
                <span v-else-if="item.label == '其他要求'">
                  <el-select v-model="scope.row.otherRequirementsList" multiple placeholder="请选择" style="width: 100px">
                    <el-option v-for="item in config_options.otherRequirements" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                  </el-select>
                </span>
                <span v-else-if="item.label == '含税单价（元/m³）'">
                  <el-input
                    v-model="scope.row.priceIncludinTax"
                    type="Number"
                    style="width: 100%"
                    @input="scope.row.priceIncludinTax = $regExp.checkNum4(scope.row.priceIncludinTax)"
                    @blur="scope.row.priceIncludinTax = $regExp.blurCheckNum(scope.row.priceIncludinTax)"
                  >
                  </el-input>
                </span>
                <span v-else-if="item.label == '不含税单价（元/m³）'">
                  <span>{{ ((scope.row.priceIncludinTax * 1) / (1 + data.taxRate * 1)).toFixed(2) || "0.00" }}</span>
                </span>
                <div v-else>
                  <el-button class="bottom_two" size="mini" @click="deleteFun(scope.$index)"> 删除 </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 第二部分 -->
        <div style="margin-top: 10px">
          <el-table :header-cell-style="{ background: '#f3f6f9' }" border stripe style="width: 100%" :data="tableData_other" tooltip-effect="dark">
            <el-table-column v-for="(item, index) in table_other" :key="index" :prop="item.prop" :label="item.label" :width="item.width" align="center" :fixed="item.label == '操作' ? 'right' : false">
              <template slot-scope="scope">
                <span v-if="item.label == '费用标准'">
                  <el-select v-model="scope.row.costStandard" placeholder="请选择" style="width: 100px">
                    <el-option v-for="item in table_other_options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                  </el-select>
                </span>
                <span v-else-if="item.label == '含税价格'">
                  <el-input
                    v-model="scope.row.priceIncludinTax"
                    type="Number"
                    style="width: 200px"
                    @input="scope.row.priceIncludinTax = $regExp.checkNum4(scope.row.priceIncludinTax)"
                    @blur="scope.row.priceIncludinTax = $regExp.blurCheckNum(scope.row.priceIncludinTax)"
                  >
                  </el-input>
                </span>
                <span v-else-if="item.label == '不含税价格'">
                  <span>{{ ((scope.row.priceIncludinTax * 1) / (1 + data.taxRate * 1)).toFixed(2) || "0.00" }}</span>
                </span>
                <span v-else>{{ scope.row[item.prop] || "*" }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 第三部分 -->
        <div>
          <div style="display: flex; flex-direction: row; justify-content: flex-start; align-items: center; margin-top: 10px">
            <div>同比例砂浆：</div>
            <el-select v-model="mortar.strengthGradeId" disabled placeholder="请选择" style="width: 120px">
              <el-option v-for="item in [{ id: '0001', name: '相同强度' }, ...config_options.strengthGrade]" :key="item.id" :label="item.name" :value="item.id" @click.native="selectStrengthGradeMortarFun(item)"> </el-option>
            </el-select>
            <div style="margin-left: 10px">类型：</div>
            <el-select v-model="mortar.type" placeholder="请选择" style="width: 120px">
              <el-option key="1" label="倍数" :value="1"> </el-option>
              <el-option key="2" label="固定金额" :value="2"> </el-option>
            </el-select>
            <div style="margin-left: 10px">{{ mortar.type == 2 ? "固定金额:" : "倍数:" }}</div>
            <el-input v-model="mortar.multiple" style="width: 120px" placeholder="请输入内容"> </el-input>
          </div>
          <div style="display: flex; flex-direction: row; justify-content: flex-start; margin-top: 10px">
            <div style="margin-right: 10px">上传附件:</div>
            <FileComponent2 style="width: 600px" fileCode="priceFile" :files="files" @deleteFile="deleteFile" @uplodeSuccess="uplodeSuccess" />
          </div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="bottom_all_two" @click="close()">取 消</el-button>
      <el-button class="bottom_all" style="margin-left: 24px" @click="save()">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { queryDisclose, queryReadjustCostDetail, saveOrUpdateConsultPrice } from "@/api/GHnumber/contractPrice.js";
import FileComponent2 from "@/views/platform/ICPS/internetSales/components/fileComponent";
export default {
  components: {
    FileComponent2,
  },
  props: {
    specialPriceDialog: {
      type: Boolean,
      default: false,
    },
    data: {
      effectiveTime: "",
    },
  },
  watch: {
    specialPriceDialog(value) {
      if (value) {
        this.queryDiscloseFun();
        this.queryReadjustCostDetailFun();
      }
    },
  },
  data() {
    return {
      tableData: [],
      table: [
        { label: "强度等级", width: "auto", prop: "strengthGrade", status: true },
        { label: "性能等级", width: "auto", prop: "priceType", status: true },
        { label: "材料要求", width: "auto", prop: "taxRate", status: true },
        { label: "特殊要求", width: "auto", prop: "createUserName", status: true },
        { label: "外加剂要求", width: "auto", prop: "createUserName", status: true },
        { label: "其他要求", width: "auto", prop: "createUserName", status: true },
        { label: "含税单价（元/m³）", width: "auto", prop: "createUserName", status: true },
        { label: "不含税单价（元/m³）", width: "auto", prop: "createUserName", status: true },
        { label: "操作", width: "auto", prop: "", status: true },
      ],
      tableData_other: [],
      table_other: [
        { label: "特殊产品", width: "auto", prop: "productName", status: true },
        { label: "费用标准", width: "auto", prop: "costStandard", status: true },
        { label: "含税价格", width: "auto", prop: "priceIncludinTax", status: true },
        { label: "不含税价格", width: "auto", prop: "priceExcludingTax", status: true },
      ],
      table_other_options: [
        { value: 1, label: "按车收费" },
        { value: 0, label: "不收费" },
        { value: 2, label: "按方量收费" },
      ],
      config_options: {
        strengthGrade: [],
        performanceGrade: [],
        meterialRequirements: [],
        otherRequirements: [],
        admixtureRequirements: [],
        specialRequirements: [],
      },
      mortar: {
        multiple: 0,
        type: 1,
        strengthGradeId: "0001",
        strengthGrade: "相同强度",
      },
      files: [],
    };
  },
  methods: {
    close() {
      this.tableData = [];
      this.$emit("closeSpecialPriceDialog", false);
    },
    save() {
      if (!this.tableData) {
        this.$message({ message: "请添加数据！", type: "warning" });
        return;
      }
      this.tableData.forEach(item => {
        // 性能等级
        let performanceGradeArr = [];
        item.performanceGradeList.forEach(v => {
          let performanceGradeItem = this.config_options.performanceGrade.find(e => e.id == v);
          performanceGradeArr.push(performanceGradeItem);
        });
        item.performanceGrade = JSON.stringify(performanceGradeArr);
        console.log(" 性能等级---------- ", item.performanceGrade);
        // 性能等级
        let meterialRequirementsArr = [];
        item.meterialRequirementsList.forEach(v => {
          let meterialRequirementsItem = this.config_options.meterialRequirements.find(e => e.id == v);
          meterialRequirementsArr.push(meterialRequirementsItem);
        });
        item.meterialRequirements = JSON.stringify(meterialRequirementsArr);
        console.log(" 材料要求---------- ", item.meterialRequirements);
        // 特殊要求
        let specialRequirementsArr = [];
        item.specialRequirementsList.forEach(v => {
          let specialRequirementsItem = this.config_options.specialRequirements.find(e => e.id == v);
          specialRequirementsArr.push(specialRequirementsItem);
        });
        item.specialRequirements = JSON.stringify(specialRequirementsArr);
        console.log(" 特殊要求---------- ", item.specialRequirements);
        // 特殊要求
        let admixtureRequirementsArr = [];
        item.admixtureRequirementsList.forEach(v => {
          let admixtureRequirementsItem = this.config_options.admixtureRequirements.find(e => e.id == v);
          admixtureRequirementsArr.push(admixtureRequirementsItem);
        });
        item.admixtureRequirements = JSON.stringify(admixtureRequirementsArr);
        console.log(" 外加剂要求---------- ", item.admixtureRequirements);
        // 其他要求
        let otherRequirementsArr = [];
        item.otherRequirementsList.forEach(v => {
          let otherRequirementsItem = this.config_options.otherRequirements.find(e => e.id == v);
          otherRequirementsArr.push(otherRequirementsItem);
        });
        item.otherRequirements = JSON.stringify(otherRequirementsArr);
        console.log(" 其他要求---------- ", item.admixtureRequirements);
        // 不含税单价
        item.priceExcludingTax = ((item.priceIncludinTax * 1) / (1 + this.data.taxRate * 1)).toFixed(2);
      });
      let productTypesList = this.tableData_other.map(item => {
        return {
          costStandard: item.costStandard,
          priceExcludingTax: ((item.priceIncludinTax * 1) / (1 + this.data.taxRate * 1)).toFixed(2),
          priceIncludinTax: item.priceIncludinTax,
          productId: item.productId,
          productName: item.productName,
        };
      });
      let type = false;
      // productTypesList.forEach(item => {
      //   if (item.priceIncludinTax !== 0 && !item.priceIncludinTax) {
      //     type = true;
      //   }
      //   if (item.costStandard !== 0 && !item.costStandard) {
      //     type = true;
      //   }
      // });
      this.tableData.forEach(item => {
        if (item.priceIncludinTax !== 0 && !item.priceIncludinTax) {
          type = true;
        }
      });
      if (type) {
        this.$message.warning("表格数据不允许为空!");
        return;
      }
      if (!this.mortar.type || !this.mortar.multiple) {
        this.$message.warning("同比例砂浆数据不允许为空!");
        return;
      }
      saveOrUpdateConsultPrice({
        readjustPricesResordId: this.data.id,
        appendix: JSON.stringify(this.files),
        priceType: this.data.priceType,
        mortar: this.mortar,
        specialPrices: this.tableData,
        productTypes: productTypesList,
      }).then(res => {
        if (res.code == 1001) {
          this.close();
        }
      });
    },
    add() {
      let specialPrices = {
        admixtureRequirements: "",
        meterialRequirements: "",
        otherRequirements: "",
        performanceGrade: "",
        priceExcludingTax: "",
        priceIncludinTax: "",
        specialRequirements: "",
        strengthGrade: "",
        strengthGradeId: "",
        performanceGradeList: [],
        meterialRequirementsList: [],
        specialRequirementsList: [],
        admixtureRequirementsList: [],
        otherRequirementsList: [],
      };
      this.tableData.push(specialPrices);
    },
    deleteFun(index) {
      this.tableData.splice(index, 1);
    },
    selectStrengthGradeFun(index, val) {
      this.tableData[index].strengthGrade = val.name;
      this.tableData[index].strengthGradeId = val.id;
    },
    selectStrengthGradeMortarFun(val) {
      this.mortar.strengthGrade = val.name;
      this.mortar.strengthGradeId = val.id;
    },
    deleteFile(index) {
      this.files.splice(index, 1);
    },
    uplodeSuccess(data) {
      const params = {
        name: data.fileName,
        fileName: data.fileName,
        fileUrl: data.fileUrl,
        path: data.fileUrl,
        fileType: 1,
        type: 1,
        createTime: new Date().Format("yyyy-MM-dd hh:mm:ss"),
      };
      this.files.push(params);
    },
    queryDiscloseFun() {
      queryDisclose({ engId: this.data.contractId }).then(res => {
        if (res.code == 1001) {
          console.log(" ", res.data);
          this.config_options = res.data;
        }
      });
    },
    queryReadjustCostDetailFun() {
      queryReadjustCostDetail({ readjustPricesResordId: this.data.id, priceType: this.data.priceType }).then(res => {
        if (res.code == 1001) {
          this.tableData = res.data.specialPrices.map(item => {
            item.performanceGradeList = item.performanceGradeId ? item.performanceGradeId.split(",") : [];
            item.meterialRequirementsList = item.meterialRequirementsId ? item.meterialRequirementsId.split(",") : [];
            item.specialRequirementsList = item.specialRequirementsId ? item.specialRequirementsId.split(",") : [];
            item.admixtureRequirementsList = item.admixtureRequirementsId ? item.admixtureRequirementsId.split(",") : [];
            item.otherRequirementsList = item.otherRequirementsId ? item.otherRequirementsId.split(",") : [];
            return item;
          });
          this.$refs.table1.doLayout();
          if (res.data.productTypes) {
            this.tableData_other = res.data.productTypes;
          }
          if (res.data.mortar) {
            this.mortar = res.data.mortar;
            this.mortar.strengthGradeId = "0001";
            this.mortar.strengthGrade = "相同强度";
          }
          this.files = JSON.parse(res.data.appendix) || [];
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>